import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost } from './client'

/**
 * Settings → Easeedesk → Dashboard tickets settings.
 *
 * Perechile vechi: `settings_dashboard_tickets`, `getDashboardList`,
 * `getSubcategory`, `getTicketsType`, `getStatus`, `getGroup`,
 * `saveSettingsDashboard`.
 *
 * `apiGet` / `apiPost` pun ELE `/api/v2` in fata caii.
 */

export interface NamedOption {
  ID: number
  name: string
}

export interface CheckedOption extends NamedOption {
  checked: boolean
}

export interface DashboardSettingRow {
  ID: number
  category: string | null
  subcategory: string | null
  ticket_types: string | null
  ticket_statuses: string | null
  technicians: string | null
  managers: string | null
}

/**
 * Ce se poate alege intr-o casuta.
 *
 * `shows_*` vin de la server, dupa NUMELE randului. In portal, ce blocuri se
 * arata era hotarat in JavaScript, dintr-o lista de vreo douazeci de numere de
 * subcategorie scrise de mana - alta pe fiecare instalare.
 */
export interface DashboardOptions {
  category: NamedOption
  subcategory: NamedOption
  shows_ticket_types: boolean
  shows_statuses: boolean
  shows_groups: boolean
  group_role: 'technicians' | 'managers' | null
  ticket_types: CheckedOption[]
  statuses: CheckedOption[]
  groups: CheckedOption[]
}

const BASE = '/settings/easeedesk/dashboard_tickets'

export function dashboardTicketsPageQuery() {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'dashboard_tickets'],
    queryFn: () => apiGet<{ title: string; moduleUrl: string; categories: NamedOption[] }>(BASE),
  })
}

export function dashboardTicketsTableQuery(search: string, start: number, length: number) {
  const query = `draw=1&start=${start}&length=${length}&search[value]=${encodeURIComponent(search)}`
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'dashboard_tickets', 'table', search, start, length],
    queryFn: () =>
      apiGet<{ draw: number; recordsTotal: number; recordsFiltered: number; data: DashboardSettingRow[] }>(
        `${BASE}/table?${query}`,
      ),
  })
}

export function dashboardTicketsSubcategories(category: number) {
  return apiGet<{ subcategories: NamedOption[] }>(`${BASE}/categories/${category}/subcategories`)
}

export function dashboardTicketsOptions(category: number, subcategory: number) {
  return apiGet<DashboardOptions>(`${BASE}/options?category=${category}&subcategory=${subcategory}`)
}

export function saveDashboardTickets(form: {
  category: number
  subcategory: number
  selected_tickets: number[]
  status: number[]
  group: number[]
}) {
  return apiPost<{ ok?: boolean }>(BASE, { ...form })
}
